import { useQueryClient } from "@tanstack/react-query";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import { waitForPortalAccess } from "./authProvider";
import { PORTAL_ACCESS_REFRESH_EVENT } from "./refreshPortalAccess";

export const PortalAccessRefresh = () => {
  const queryClient = useQueryClient();
  const { pathname } = useLocation();

  useEffect(() => {
    const refresh = async () => {
      await waitForPortalAccess();
      void queryClient.invalidateQueries({ queryKey: ["auth", "canAccess"], refetchType: "all" });
      void queryClient.invalidateQueries({ queryKey: ["auth", "getPermissions"] });
    };
    refresh();
    window.addEventListener("focus", refresh);
    window.addEventListener(PORTAL_ACCESS_REFRESH_EVENT, refresh);
    return () => {
      window.removeEventListener("focus", refresh);
      window.removeEventListener(PORTAL_ACCESS_REFRESH_EVENT, refresh);
    };
  }, [pathname, queryClient]);

  return null;
};
